<script setup>
  import { computed } from 'vue';
  import { useProForecastStore } from '@/stores/ProForecastStore';
  import ProForecastHeader from '@/components/ProForecastHeader.vue';
  import ProForecastBodyExtended from '@/components/ProForecastBodyExtended.vue';

  const props = defineProps({
    proForecast: {
      type: Object,
      required: true
    },
    requestedForecastType: {
      type: String,
      required: true
    }
  });

  const proForecastStore = useProForecastStore();

  const forecaster = computed(() => proForecastStore.getForecaster(props.proForecast.forecaster_member_id));
  console.log(props.proForecast)
</script>

<template>
  <ProForecastHeader :proForecast="props.proForecast" :forecaster="forecaster" :extended="true" :requestedForecastType="props.requestedForecastType"  />
  <ProForecastBodyExtended :proForecast="props.proForecast" />
</template>